import React, { useState } from "react";
import { Box, Typography, Grid, Paper, MenuItem, Select, Card, CardContent } from "@mui/material";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

export const ProductManagerDashboard = () => {
  const [filter, setFilter] = useState("monthly"); // Filter for monthly/yearly view

  // Dummy data for the graphs
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const teamMembers = ["Alice", "Bob", "Charlie", "Diana", "Eve"];

  const taskCompletionData = {
    labels: months,
    datasets: [
      {
        label: "Tasks Completed",
        data: [40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150],
        borderColor: "#4caf50",
        backgroundColor: "rgba(76, 175, 80, 0.2)",
        tension: 0.4,
      },
    ],
  };

  const featureProgressData = {
    labels: months,
    datasets: [
      {
        label: "Feature Progress",
        data: [20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130],
        borderColor: "#2196f3",
        backgroundColor: "rgba(33, 150, 243, 0.2)",
        tension: 0.4,
      },
    ],
  };

  const teamPerformanceData = {
    labels: teamMembers,
    datasets: [
      {
        label: "Tasks Completed",
        data: [50, 60, 70, 80, 90],
        backgroundColor: ["#4caf50", "#2196f3", "#ff9800", "#9c27b0", "#f44336"],
      },
    ],
  };

  const customerFeedbackData = {
    labels: ["Positive", "Neutral", "Negative"],
    datasets: [
      {
        label: "Customer Feedback",
        data: [70, 20, 10],
        backgroundColor: ["#4caf50", "#ffeb3b", "#f44336"],
      },
    ],
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  return (
    <Box sx={{ padding: "24px" }}>
      {/* Page Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          marginBottom: "16px",
          textAlign: "center",
        }}
      >
        Product Manager Dashboard
      </Typography>

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ marginBottom: "24px" }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Tasks Completed
              </Typography>
              <Typography variant="h4" sx={{ color: "#4caf50", fontWeight: "bold" }}>
                1,200
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Features in Progress
              </Typography>
              <Typography variant="h4" sx={{ color: "#2196f3", fontWeight: "bold" }}>
                15
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Team Members
              </Typography>
              <Typography variant="h4" sx={{ color: "#ff9800", fontWeight: "bold" }}>
                5
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Customer Feedback
              </Typography>
              <Typography variant="h4" sx={{ color: "#4caf50", fontWeight: "bold" }}>
                70% Positive
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filter Section */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
        <Select
          value={filter}
          onChange={handleFilterChange}
          sx={{ minWidth: "150px" }}
        >
          <MenuItem value="monthly">Monthly View</MenuItem>
          <MenuItem value="yearly">Yearly View</MenuItem>
        </Select>
      </Box>

      {/* Graphs Section */}
      <Grid container spacing={3}>
        {/* Task Completion */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: "16px" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
              Task Completion Over Time
            </Typography>
            <Line data={taskCompletionData} options={{ responsive: true }} />
          </Paper>
        </Grid>

        {/* Feature Progress */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: "16px" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
              Feature Progress Over Time
            </Typography>
            <Line data={featureProgressData} options={{ responsive: true }} />
          </Paper>
        </Grid>

        {/* Team Performance */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: "16px" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
              Team Performance
            </Typography>
            <Doughnut data={teamPerformanceData} options={{ responsive: true }} />
          </Paper>
        </Grid>

        {/* Customer Feedback */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ padding: "16px" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
              Customer Feedback
            </Typography>
            <Doughnut data={customerFeedbackData} options={{ responsive: true }} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductManagerDashboard;